<template>
<div class="link-btn">
  <div class="link-btn-wrapper"
    @click="linkClick"
    @mouseover="overLinkHandle"
    @mouseout="outLinkHandle">
    {{linkLabel}}
    <span
      v-show="isDeleteLink"
      class="el-icon-error del-icon"
      @click.stop="deleteLinkClick"
    />
  </div>
</div>
</template>

<script>

export default {
    name: "LinkButton",
    props: ["data"],
    data() {
        return {
            linkLabel: this.getLinkType(this.data.urlType, this.data.url),
            isDeleteLink: false
        }
    },
    methods: {
        linkClick() {
            this.$store.dispatch('zhiji/showModal', {
                type: 'LinkWordEditModal',
                data: {
                    colorType: this.data.urlType || 'outColor',
                    hideColor: true,
                    hideWord: true,
                    url: this.data.url,
                    colorData: {
                        outColor: '',
                        innerColor:'',
                    },
                    newPage: this.data.newPage || '',
                    urlCmd: this.data.urlCmd,
                    confirm: (link) => {
                        const { url, urlType: {colorType}, linkNewTxt: {cmd}, newPage } = link;

                        this.linkLabel = this.getLinkType(colorType, url);
                        this.$emit('linkChange', {
                            url,
                            urlType: colorType,
                            urlCmd: cmd,
                            newPage,
                        })
                    },
                    cancel: () => {},
                }
            });
        },
        deleteLinkClick() {
            this.linkLabel = this.$t("zhiji.answer.textWidget.textLink");
            this.$emit('linkChange', {
                url: '',
                urlType: ''
            })
        },
        overLinkHandle() {
            if(this.linkLabel != this.$t("zhiji.answer.textWidget.textLink")) {
                this.isDeleteLink = true;
            }
        },
        outLinkHandle() {
            this.isDeleteLink = false;
        },
        getLinkType(type, url) {
            let label = '';
            if (!url) {
                label = this.$t("zhiji.answer.textWidget.textLink")
            } else {
                const linkType = {
                    innerColor: this.$t("zhiji.knowlege.linkWordModal.innerLink"),
                    outColor: this.$t("zhiji.knowlege.linkWordModal.outerLink")
                };
                label = linkType[type] ? linkType[type] : this.$t("zhiji.answer.textWidget.textLink");
            }
            return label;
        }
    }
}

</script>

<style lang="less" scoped>
.link-btn {
    border-top: 1px solid #D8E4F0;
    position: relative;
    background: #fff;
    border-radius: 0 0 4px 4px;
    padding: 8px 10px;
    cursor: pointer;
    .link-btn-wrapper{
        text-align: center;
        padding: 6px 20px;
        border-radius: 20px;
        border: 1px solid #d8e4f0;
        font-size: 12px;
        &::before{
            display: inline-block;
            content: "";
            width: 15px;
            height: 15px;
            vertical-align: -3px;
            background: url('//ossweb-img.qq.com/images/xiaoyue/images/manager/website/class-spr2.png') -322px 0;
        }
    }
    .del-icon {
       position: absolute;
        right: 8px;
        cursor: pointer;
        font-size: 18px;
        top: 5px;
    } 
}
</style>